import { render, staticRenderFns } from "./mPaymentPostingListing.vue?vue&type=template&id=54f30dd0&"
import script from "./mPaymentPostingListing.vue?vue&type=script&lang=js&"
export * from "./mPaymentPostingListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports